export default __webpack_public_path__ + "static/media/frontend2.d9a4deef.svg";